import BaseModal from './BaseModal';
import s from './BaseModal.module.css';
import l from './LoginModal.module.css';
import { formatWithCommas } from 'functions/fields';

const ContactUsModal = ({contactsToday, dailyContactsLimit, onClose}) => {
    const openCalendly = () => {
        window.open('https://calendly.com/client-acquisition-ai/access-verification', '_blank', 'noopener,noreferrer');
    }

    return ( 
        <BaseModal height="25rem" onClose={onClose}>
            <div className={l.loginModalContainer}>
                <div className={l.title}>
                    Need more contacts per day?
                </div>
                <div className={l.subtitle}>
                    You've already saved {formatWithCommas(contactsToday)} contacts today, and we enforce a soft daily limit for unverified accounts (to prevent abuse). <br /><br />In order for us to verify your business and release the daily limit, feel free to book a call.
                </div>
                <div className={`${s.blackButton} ${l.button}`} onClick={openCalendly}>Book A Call</div>
            </div>
        </BaseModal>
     );
}
 
export default ContactUsModal;